export type OrgKey = "neutral" | "barnes" | "penn";

export const ORG_IDS = {
  BARNES: 1,
  PENN: 2,
} as const;

export function getOrgKey(organizationId?: number | null): OrgKey {
  if (organizationId === ORG_IDS.BARNES) return "barnes";
  if (organizationId === ORG_IDS.PENN) return "penn";
  return "neutral";
}

export const ORG_CONFIG: Record<
  OrgKey,
  {
    platformName: string;
    supportEmail?: string;
    supportPhone?: string;
    welcomeLine: string;
    onDemandHeader: string;
    chatSystemSender: { name: string; color: string };
    brand: { primary: string; accent: string };
    AVDeniedHelp: string;
    errorHelp: string;
  }
> = {
  neutral: {
    platformName: "Visual Experience Platform (VxP)",
    welcomeLine: "Welcome to the Visual Experience Platform (VxP)!",
    onDemandHeader: "Welcome to VxP On Demand Classes!",
    chatSystemSender: { name: "VxP Team", color: "#555" },
    brand: { primary: "#000", accent: "#888" },
    AVDeniedHelp: "If you need assistance, contact support.",
    errorHelp: "Something went wrong. If you need assistance, contact support.",
  },
  barnes: {
    supportEmail: "support@barnesclasses.org",
    supportPhone: "267.831.4464",
    platformName: "Visual Experience Platform (VxP)",
    welcomeLine:
      "Welcome to the Barnes Foundation's Visual Experience Platform (VxP)!",
    onDemandHeader:
      "Welcome to the Barnes Foundation's On Demand Classes on the VxP!",
    chatSystemSender: { name: "Barnes Foundation", color: "#d64220" },
    brand: { primary: "#d64220", accent: "#000" },
    AVDeniedHelp:
      "Please reach out to our Student Help Desk line at 267.831.4464 or email support@barnesclasses.org",
    errorHelp:
      "Something went wrong. Please reach out to our Student Help Desk line at 267.831.4464 or email support@barnesclasses.org",
  },
  penn: {
    supportEmail: "events@pennmuseum.org",
    platformName: "Visual Experience Platform (VxP)",
    welcomeLine: "Welcome to the Visual Experience Platform (VxP)!",
    onDemandHeader: "Welcome to Penn Museum's On Demand Classes on the VxP!",
    chatSystemSender: { name: "Penn Museum", color: "#005f9e" },
    brand: { primary: "#005f9e", accent: "#990000" },
    AVDeniedHelp: "If you need assistance, please email events@pennmuseum.org",
    errorHelp:
      "Something went wrong. If you need assistance, please email events@pennmuseum.org",
  },
};
